// Textes du marqueur de contexte condensé (sprint 6, LLM-13). Fonction pure (tests node).

const nf = new Intl.NumberFormat('fr-FR');

/**
 * Texte du marqueur de contexte condensé (sprint 6, LLM-13), d'après `context_compacted`.
 * La coupe tombe toujours sur une question : `messages_couverts` est pair et le marqueur
 * parle en échanges (question + réponse), comme le fil affiché.
 * - summary / server : les plus anciens échanges sont résumés, les chiffres seront re-vérifiés ;
 * - truncation : les plus anciens échanges ne sont plus transmis (aucun résumé).
 */
export function compactionText(compaction) {
  if (!compaction) return '';
  const n = compaction.messages_couverts > 0 ? Math.ceil(compaction.messages_couverts / 2) : 0;
  const exchanges = `${nf.format(n)} échange${n > 1 ? 's' : ''}`;
  if (compaction.mode === 'truncation') {
    return n > 0
      ? `Les plus anciens échanges ne sont plus transmis à l'assistant (${exchanges})`
      : "Les plus anciens échanges ne sont plus transmis à l'assistant";
  }
  const scope = n > 0
    ? (n > 1 ? `les ${nf.format(n)} premiers échanges sont résumés pour la suite` : 'le premier échange est résumé pour la suite')
    : 'les premiers échanges sont résumés pour la suite';
  return `Contexte condensé — ${scope} (les chiffres seront re-vérifiés)`;
}


/**
 * Indices des réponses dont le marqueur répète le précédent, pour n'afficher qu'un
 * séparateur dans le fil (le premier, là où le contexte a été condensé) :
 * - résumé RÉUTILISÉ (`reutilise: true`) avec le même mode et la même portée que le
 *   dernier marqueur affiché ;
 * - troncature qui suit un marqueur de troncature déjà affiché (la portée avance au fil
 *   des tours, l'information reste la même).
 */
export function repeatedCompactions(messages) {
  const hidden = new Set();
  let shown = null;
  (messages || []).forEach((message, index) => {
    const c = message?.role === 'assistant' ? message.compaction : null;
    if (!c) return;
    const sameReuse = c.reutilise === true && shown && shown.mode === c.mode && shown.messages_couverts === c.messages_couverts;
    const repeatedTruncation = c.mode === 'truncation' && shown?.mode === 'truncation';
    if (sameReuse || repeatedTruncation) {
      hidden.add(index);
      return;
    }
    shown = c;
  });
  return hidden;
}
